:host {
  display: block;
}

.spw-footer-content {
  background: #1d1d1d;
  color: var(--spw-ds-white);
  padding: 32px 0;

  &__container {
    display: flex;
    flex-wrap: wrap;
  }
}

::slotted(spw-footer-content-col) {
  width: 100%;
  margin-bottom: 24px;
  position: relative;

  @include breakpoint(md) {
    width: 50%;
    gap: 48px;
  }
  @include breakpoint(lg) {
    width: 25%;
    gap: 0;
    padding-right: 48px;
    padding-left: 48px;
    margin-bottom: 0;
    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 1px;
      background: var(--spw-ds-primary);
      opacity: 0.3;
    }
  }
}

::slotted(spw-footer-content-col:first-child) {
  padding-left: 0;
}

::slotted(spw-footer-content-col:last-child) {
  padding-right: 0 !important;
  margin-bottom: 0;
  &:after {
    display: none;
  }
}
